import { useContext } from "preact/hooks";
import { useMutation } from "@apollo/client";
import { GlobalContext } from "@/context/GlobalContext";
import useLocalStorageState from "use-local-storage-state";
import { trackBeginCheckout } from "@/gtm-analytics";
import { surfsideTrackBeginCheckout } from "@/shared/surfside-analytics";
import useSnackBar from "@/hooks/useSnackBar";
import REMOVE_ITEM_FROM_CART from "@/mutations/removeItemFromCart";
import UPDATE_QUANTITY_MUTATION from "@/mutations/updateQuantity";

function useSideCart() {
	const { sideCartOpen, setSideCartOpen } = useContext(GlobalContext);
	const { checkout, setCheckout } = useContext(GlobalContext);
	const [retailer, setRetailer] = useLocalStorageState("dutchie_retailer", null);
	const retailerSlug = retailer?.slug;
	const retailerId = retailer?.id;
	const [checkoutId, setCheckoutId] = useLocalStorageState("dutchie_checkout_" + retailerSlug);
	const [cartItems, setCartItems] = useLocalStorageState("dutchie_cart_items");
	const [promo, setPromo] = useLocalStorageState("cp_promo");
	let currentRetailer = dutchie.retailers.find(
		(retailer) => retailer?.id === retailerId
	);

	const { handleOpen } = useSnackBar();

	const [removeFromCart, { loading: removeLoading, error: mutationError, data: dataError }] = useMutation(REMOVE_ITEM_FROM_CART);
	const [updateQuantity, { loading: quantityLoading }] = useMutation(
		UPDATE_QUANTITY_MUTATION,
		{
			onCompleted(data) { },
			onError(error) {
				handleOpen(error.message);
			},
		}
	);


	function changeQuantityValue(value, item) {
		let selectedVariant = item.product.variants.find((variant) => { return variant.option === item.option });

		if (value > selectedVariant.quantity) {
			return;
		}

		if (value < 1 || value > 10) {
			return;
		}

		updateQuantity({
			variables: {
				retailerId: retailerId,
				quantity: parseInt(value),
				checkoutId: checkoutId,
				itemId: item.id,
			},
		});
	}

	function trackCheckout() {

		if (checkout && Object.hasOwn(checkout, 'priceSummary')) {
			let retailerName = localStorage.getItem('dutchie_retailer').name;

			let trackedItems = {
				currency: "USD",
				value: checkout.priceSummary.subtotal / 100,
				items: [],
				tax: checkout.priceSummary.taxes / 100,
			};

			checkout.items.map(function (item, index) {
				let special = JSON.parse(sessionStorage.getItem(`cp_promo_item_${item.product.id}`));
				let weight = item.product.variants.find((variant) => variant.option === item.option);

				trackedItems.items.push({
					item_id: item.product.id,
					item_name: item.product.name,
					affiliation: retailer.name,
					coupon: special?.promotion_id,
					promotion_id: special?.promotion_id,
					promotion_name: special?.promotion_name,
					discount: item.discounts?.total / 100,
					index,
					item_category: item.product.category,
					item_brand: item.product.brand?.name,
					item_variant: item.option,
					price: item.product.variants[0].priceRec,
					location_id: retailerId,
					quantity: item.quantity,
				});
			});
			trackBeginCheckout(trackedItems);
			if (typeof surf !== 'undefined') {
				surfsideTrackBeginCheckout(trackedItems, retailerName);
			}
			console.log('sidecart trackedItems');
			console.log(trackedItems);
			setCartItems(trackedItems);
		}
	}

	return { trackCheckout, changeQuantityValue, removeFromCart, removeLoading, quantityLoading, sideCartOpen, setSideCartOpen }
}
export default useSideCart;